export default function StrategyOfferSection({ onTalkClick }) {
  return (
    <section className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20">
      <div className="mx-auto flex max-w-5xl flex-col gap-8 px-5 text-center text-white md:flex-row md:items-center md:px-6 md:text-left">
        <div className="flex-1">
          <p className="text-sm uppercase tracking-[0.2em] text-sky-300/80">Free growth session</p>
          <h2 className="mt-3 text-3xl font-semibold md:text-4xl">Leave with a 90-day action map</h2>
          <p className="mt-4 text-slate-200">
            We audit your funnel beforehand, so the call focuses on quick wins, media mix, and the order we’d launch
            everything.
          </p>
        </div>
        <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-white/10 p-6 backdrop-blur">
          <ul className="space-y-3 text-sm text-slate-100">
            <li>✅ Funnel teardown with traffic + conversion priorities</li>
            <li>✅ Week-by-week launch plan for the first sprint</li>
            <li>✅ Benchmarks vs. top performers in your space</li>
          </ul>
          <button
            type="button"
            onClick={() => onTalkClick?.()}
            className="mt-6 inline-flex w-full items-center justify-center rounded-full bg-white px-5 py-3 text-sm font-semibold text-slate-900 shadow hover:bg-slate-100"
          >
            Book my strategy session →
          </button>
          <p className="mt-3 text-xs text-slate-300">We hold just five of these sessions per month — claim a spot now.</p>
        </div>
      </div>
    </section>
  );
}
